import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-modal-np-dropship-info',
  templateUrl: './modal-np-dropship-info.component.html',
  styleUrls: ['./modal-np-dropship-info.component.scss']
})
export class ModalNpDropshipInfoComponent {
  // Нова схема дропшипу (картка #867): наклейку і реєстр клієнт завантажує у формі, а не шле листом
  @Input() newScheme = false;
  public isModalShow: boolean = false;
  public isDarkBackground: boolean = false;

  show() {
    this.isModalShow = true;
    this.isDarkBackground = true;
  }
  closeModal() {
    this.isModalShow = false
    this.isDarkBackground = false;
  }
}
